'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosCopyOutline = function IoIosCopyOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm23.5 7.5v5h5v1.3h-6.2v-6.3h1.2z m1.6-2.5l5.9 5.9v20.4h-3.7v3.7h-18.8v-26.2h3.8v-3.8h12.8z m0.9 28.8v-2.5h-13.7v-21.3h-2.5v23.8h16.2z m3.8-3.8v-18.6l-5.1-5.1h-11.2v23.7h16.3z' })
        )
    );
};

exports.default = IoIosCopyOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-copy-outline.js
// module id = 2621
// module chunks = 168707334958949